import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
import {Link} from 'react-scroll';

export const Home = () => {
  return (
<div name='home' className='w-full h-screen z-1'>
    <div className='max-w-[1000p] mx-auto px-20 flex flex-col justify-center h-full'>
        <p className='text-pink-600'>Hi, my name is</p>
        <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>Stanley</h1>
        <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>I build & scale creative products</h2>
        <p className=' text-[#8892b0] py-4 max-w-[700px]'> Wake up, Talk to users, Build, Repeat.</p>
        <div>
        <Link to="projects" smooth={true} duration={500} offset={-80}>
            <button className='text-[#ccd6f6] group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
                    View Work 
                    <span className='group-hover:rotate-90 duration-300'>
                        <HiArrowNarrowRight className='ml-3'/>
                    </span>
                </button>  
             </Link>
                    
        </div>
    </div>
   </div>  
   
    )
}
